var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruckReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 4C2.89543 4 2 4.89543 2 6V16C2 16.9321 2.63766 17.7153 3.50056 17.9371C3.53409 16.0331 5.088 14.5 7 14.5C8.933 14.5 10.5 16.067 10.5 18H13.5C13.5 16.067 15.067 14.5 17 14.5C18.912 14.5 20.4659 16.0331 20.4994 17.9371C21.3623 17.7153 22 16.9321 22 16V12.75H15V11.25H21.4L18.6005 7.75061C18.2209 7.27618 17.6463 7 17.0387 7H15V6C15 4.89543 14.1046 4 13 4H4ZM7.50205 8.44276C7.80981 8.71999 7.83455 9.19422 7.55732 9.50198L6.20609 11.002C6.06841 11.1548 5.87401 11.2444 5.66837 11.2497C5.46274 11.2551 5.26393 11.1758 5.11849 11.0303L3.61866 9.5303C3.32578 9.23739 3.32581 8.76252 3.61872 8.46964C3.91163 8.17676 4.3865 8.17679 4.67938 8.4697L4.84916 8.63951C5.23783 6.98286 6.72431 5.75 8.5001 5.75C10.5721 5.75 12.2501 7.42838 12.2501 9.5C12.2501 11.5716 10.5721 13.25 8.5001 13.25C8.08589 13.25 7.7501 12.9142 7.7501 12.5C7.7501 12.0858 8.08589 11.75 8.5001 11.75C9.74357 11.75 10.7501 10.7433 10.7501 9.5C10.7501 8.25674 9.74357 7.25 8.5001 7.25C7.64876 7.25 6.90847 7.7219 6.52623 8.41852C6.80804 8.18829 7.22332 8.19167 7.50205 8.44276Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 18C9 19.1046 8.10457 20 7 20C5.89543 20 5 19.1046 5 18C5 16.8954 5.89543 16 7 16C8.10457 16 9 16.8954 9 18Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 18C19 19.1046 18.1046 20 17 20C15.8954 20 15 19.1046 15 18C15 16.8954 15.8954 16 17 16C18.1046 16 19 16.8954 19 18Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckReload);
export default __webpack_public_path__ + "static/media/truck-reload.6d5025b93f483404eba360bf45234d32.svg";
export { ForwardRef as ReactComponent };